import request from "@/utils/request";

/**
 * 获取土地资源列表
 * @param {String} district - 行政区域
 * @param {String} trade_type - 交易类型 1：协议交易 2：挂牌交易 3：拍卖交易 4：网上推介
 * @param {String} type - 流转方式 1：转让 2：出租 3：抵押
 * @param {String} use_type - 土地用途
 * @param {String} land_type - 土地性质 1：国有建设用地 2：集体建设用地 3：农村流转土地
 * @param {String} status - 项目状态 2:交易中 3:已成交
 * @param {String} page - 页码
 * @returns Promise
 */
export const projectList = ({
  page,
  district,
  type,
  use_type,
  land_type,
  status,
  trade_type,
}) => {
  return request("/project/list", "post", {
    page,
    district,
    type,
    use_type,
    land_type,
    status,
    trade_type,
  });
};

/**
 * 获取土地资源详情
 * @param {String} id - id
 * @returns Promise
 */
export const projectDetail = ({ id }) => {
  return request("/project/detail", "post", {
    id,
  });
};

/**
 * 获取土地需求列表
 * @param {String} district - 行政区域
 * @param {String} type - 流转方式 1：求租 2：求购
 * @param {String} use_type - 土地用途
 * @param {String} land_type - 土地性质 1：国有建设用地 2：集体建设用地 3：农村流转土地
 * @param {String} page - 页码
 * @returns Promise
 */
export const demandList = ({ page, district, type, use_type, land_type }) => {
  return request("/demand/list", "post", {
    page,
    district,
    type,
    use_type,
    land_type,
  });
};

/**
 * 获取土地资源详情
 * @param {String} id - id
 * @returns Promise
 */
export const demandDetail = ({ id }) => {
  return request("/demand/detail", "post", {
    id,
  });
};

/**
 * 土地供应拍卖交易 - 报名
 * @param {String} project_id - 土地供应ID
 * @returns Promise
 */
export const projectEnroll = ({ project_id }) => {
  return request("/project/auction/enroll", "post", {
    project_id,
  });
};

/**
 * 土地供应拍卖交易 -  报价
 * @param {String} project_id - 土地供应ID
 * @param {String} price - 报价价格
 * @returns Promise
 */
export const projectQuote = ({ project_id, price }) => {
  return request("/project/quote", "post", {
    project_id,
    price,
  });
};

/**
 * 发布土地资源（转让、出租、抵押）
 * @param {String} data -
 * @returns Promise
 */
export const projectAdd = (data) => {
  return request("/project/add", "post", data);
};

/**
 * 修改我的土地资源（转让、出租、抵押）
 * @param {String} data -
 * @returns Promise
 */
export const projectPut = (data) => {
  return request("/project/put", "post", data);
};

/**
 * 土地供应拍卖交易 - 报名
 * @param {String} data -
 * @returns Promise
 */
export const projectAuctionEnroll = (data) => {
  return request("/project/auction/enroll", "post", data);
};

/**
 * 土地意向申请- 申请
 * @returns Promise
 */
export const getProjectIntention = (data) => {
  return request("/project/intention", "post", data);
};

/**
 * 土地意向申请- 是否申请过
 * @returns Promise
 */
export const projectIntentionGet = (data) => {
  return request("/project/intentionGet", "post", data);
};

/**
 * 转让的资源详情
 * @returns Promise
 */
export const agreementGet = ({ project_id }) => {
  return request("/project/agreementGet", "post", { project_id });
};

/**
 * 成交公示
 * @returns Promise
 */
export const noticeGet = (data) => {
  return request("/notice/get", "post", data);
};


/**
 * 成交公示
 * @returns Promise
 */
export const getQuotes = (data) => {
  return request("/project/getQuotes", "post", data);
};

/**
 * 成交公示
 * @returns Promise
 */
export const getListCon = (data) => {
  return request("/project/listCon", "post", data);
};
